import ImageSection from '../../Components/imageSection';
import { MainLayout } from '../../style/Layout';
import PrimaryButton from '../../Components/PrimaryButton';
import React from 'react';
import ReviewSection from '../../Components/ReviewSection';
import ServicesSection from '../../Components/ServicesSection';
import Title from '../../Components/Title';
import profile from '../../img/resume2.jpg'
import styled from 'styled-components';

const AboutPage = () => {
    return (
        <MainLayout>
            <AboutPageStyled>
                <Title className='mb-5' title='About' span='About' />
                {/* <div className="container">
                    <div className="row my-5">
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <div className="left-content">
                                    <img src={profile} alt="" />
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <div className="right-content">
                                    <h4>I'm <span>Fahim Hasan</span></h4>
                                    <p className="paragraph">
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Id fugit minus quisquam, similique quam consectetur deleniti sint quos blanditiis obcaecati eligendi pariatur quidem perferendis reiciendis? Nisi impedit tempore cumque perferendis!
                                    </p>
                                <div className="about-info">
                                    <div className="info-title">
                                        <p>Full Name </p>
                                        <p>Age </p>
                                        <p>Nationality </p>
                                        <p>Language </p>
                                        <p>Location </p>
                                        <p>Service </p>
                                    </div>
                                    <div className="info">
                                        <p>  : Fahim Hasan</p>
                                        <p>  : 24</p>
                                        <p>  : Bangladeshi </p>
                                        <p>  : Bangla, English</p>
                                        <p>  : Dhaka, Bangladesh </p>
                                        <p>  : Freelancer</p>
                                    </div>
                                </div>
                                <PrimaryButton title={'Download Cv'} />
                            </div>
                        </div>
                    </div>
                </div> */}
                <ImageSection />
                <ServicesSection />
                <ReviewSection />
            </AboutPageStyled>
        </MainLayout>
    );
};

const AboutPageStyled = styled.div`
/* .row {
    margin-top: 100px!important;
    .left-content {
        width: 100%;
        height: 60vh;
        img {
            width: 90%;
            height: 100%;
            object-fit: cover;
        }
    }

    .right-content {
        h4{
            font-size: 2rem;
            color: var(--white-color);
            span {
                font-size: 2rem;
            }
        }
        .paragraph {
            padding: 1rem 0;
        }
        .about-info {
            display: flex;
            padding-bottom: 1.4rem;
            .info-title {
                padding-right: 4rem;
                p{
                    font-weight: 600;
                }
            }
            .info-title, .info{
                p {
                    padding: .3rem 0;
                }
            }
        }
    }
} */

@media only screen and (max-width: 1000px){
    
}
`;

export default AboutPage;